import { ReactElement } from 'react';
import Link from 'components/UI/Link';
import { Location } from 'pages/locations';
import ScheduleAppointmentCta from 'components/UI/ScheduleAppointmentCta';
import NewLocationDetailsCard from './NewLocationDetailsCard';

type MapCardProps = {
  location: Location;
  className?: string;
  size?: string;
  factua?: boolean;
};

export default function NewMapCard({
  location,
  className,
  size = 'lg',
  factua = false,
}: MapCardProps): ReactElement {
  return (
    <div className="flex flex-row p-3">
      <NewLocationDetailsCard
        location={location}
        size={size}
        className={`${size === 'lg' ? 'space-y-2' : null} ${className}`}
      />
      <div className="flex flex-col text-center w-full">
        <ScheduleAppointmentCta
          location={location}
          colorScheme="Primary"
          wrapperClasses=""
          classNames={`${size === 'lg' ? 'button-text' : 'text-sm'} px-2 remove-cta-padding `}
          factua={factua}
          from="location"
        />
        <Link slug={`locations/${location?.slug}`}>
          <a
            className={`block text-tertiary-actual ${
              size === 'lg' ? 'button-text' : 'text-sm'
            } mt-3`}
          >
            View Location Details
          </a>
        </Link>
      </div>
    </div>
  );
}
